module.exports = __webpack_public_path__ + "static/media/icon.bac495a6.jpg";